import { CommonModule } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../@theme/services/clients.service'
import { TypesServices } from '../../../@theme/services/typeslist.service'
import { GridEditorBaseComponent } from '../../reps/shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../reps/shared/rep-editor-state.service'

@Component({
    selector: 'gd-imo',
    templateUrl: './imo.component.html',
    styleUrls: ['./imo.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        KENDO_DROPDOWNS,
        KENDO_GRID,
        KENDO_INPUTS,
        KENDO_INDICATORS,
        KENDO_DIALOGS,
        KENDO_BUTTONS,
        ColumnComponent,
        EditTemplateDirective,
        TextBoxDirective,
        FormsModule,
        ReactiveFormsModule,
        CommandColumnComponent,
        CellTemplateDirective,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
    ]
})
export class ImoComponent extends GridEditorBaseComponent implements OnInit {
  public imos: any[]

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnInit() {
    this.initGrid()
  }

  initGrid(): void {
    this.typesService.getImos().subscribe((response) => {
      this.imos = response
    })
  }

  saveHandler({
    sender,
    rowIndex,
    formGroup,
    isNew,
  }: {
    sender: any
    rowIndex: any
    formGroup: any
    isNew: any
  }): void {
    const imo = formGroup.value
    this.typesService.submitImoUpdate(imo).subscribe(() => {
      sender.closeRow(rowIndex)
      this.initGrid()
    })
  }

  addHandler({ sender }: { sender: any }) {
    this.addHandlerShared(
      { sender },
      {
        imoId: 0,
        imoName: null,
      },
    )
  }

  removeHandler({ dataItem }: { dataItem: any }) {
    throw new Error('Method not implemented.')
  }

  createFormGroup(imo: any): UntypedFormGroup {
    return this.formBuilder.group({
      imoId: [imo.imoId, Validators.required],
      imoName: [imo.imoName, Validators.required],
    })
  }
}
